import { Typography } from "@mui/material";

export const InputLabel = ({ label, style = {} }) => {
  return (
    <Typography
      sx={{
        fontSize: "16px",
        fontWeight: "500",
        color: "#676767",
        ...style,
      }}
    >
      {label}
    </Typography>
  );
};
